export default class Marquee {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        var modules = document.querySelectorAll(".marquee");
        if (modules.length > 0) {
            modules.forEach(module => {
                var marquees = module.querySelectorAll(".marquee-content");
                if (marquees.length > 0) {
                    this.checkSize(module, marquees);
                    window.addEventListener('resize', (event) => {
                        this.checkSize(module, marquees);
                    }, true);
                }
            });
        }
    }
    checkSize(module, marquees) {
        var moduleWidth = module.clientWidth;
        marquees.forEach(marquee => {
            var marqueeImages = marquee.querySelector(".marquee-images");
            if (marqueeImages) {
                if (marqueeImages.clientWidth > moduleWidth) {
                    marquee.classList.add("scroll");
                }
                else {
                    marquee.classList.remove("scroll");
                }
            }
        });
    }
}
